import './core/credits.js';
import './core/general.js';
import './components/cart.js';
import './components/bundle-builder.js';
import './components/cookieconsent.js';
import './components/fancybox.js';
import './components/header.js';
import './components/plyr.js';
import './components/product.js';
import './components/select.js';
import './components/slider.js';
import './components/tracking.js';
import '@tailwindplus/elements';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist'

// Global
window.Alpine = Alpine;

// Inits
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.start();
